import primaryLogo from 'assets/brand/primary-logo.svg';
import adpLogo from 'assets/icons/brands/adp.jpg';
import fourthLogo from 'assets/icons/brands/fourth.svg';
import iplicitLogo from 'assets/icons/brands/iplicit.png';
import ironcladLogo from 'assets/icons/brands/ironclad.svg';
import metronomeLogo from 'assets/icons/brands/metronome.svg';
import microsLogo from 'assets/icons/brands/micros.svg';
import nueLogo from 'assets/icons/brands/nue.svg';
import salesforceLogo from 'assets/icons/brands/salesforce.png';
import sevenRoomsLogo from 'assets/icons/brands/seven-rooms.svg';
import stripeLogo from 'assets/icons/brands/stripe.png';

import { brandImages } from 'pages/central-data-hub/integrations/data/integration-data';

export const SOURCE_OPTIONS = [
  { label: 'Quickbooks', value: 'QUICKBOOKS', icon: brandImages.QUICKBOOKS },
  { label: 'Netsuite', value: 'NETSUITE', icon: brandImages.NETSUITE },
  { label: 'Zoho Books', value: 'ZOHOBOOKS', icon: brandImages.ZOHOBOOKS },
  { label: 'Plaid', value: 'PLAID', icon: brandImages.PLAID },
  {
    label: 'Maximor Data',
    value: 'MAXIMOR',
    icon: primaryLogo,
  },
] as const;

// demo only - Azumi POC
export const AZUMI_SOURCE_OPTIONS = [
  { label: 'SevenRooms', value: 'SEVENROOMS', icon: sevenRoomsLogo },
  { label: 'Fourth', value: 'FOURTH', icon: fourthLogo },
  { label: 'Micros', value: 'MICROS', icon: microsLogo },
  { label: 'ADP', value: 'ADP', icon: adpLogo },
  { label: 'Iplicit', value: 'IPLICIT', icon: iplicitLogo },
] as const;

// demo only - Sierra
export const SIERRA_SOURCE_OPTIONS = [
  { label: 'Maximor', value: 'MAXIMOR', icon: primaryLogo },
  { label: 'Quickbooks', value: 'QUICKBOOKS', icon: brandImages.QUICKBOOKS },
  { label: 'Ironclad', value: 'IRONCLAD', icon: ironcladLogo },
  { label: 'Salesforce', value: 'SALESFORCE', icon: salesforceLogo },
  { label: 'Nue', value: 'NUE', icon: nueLogo },
  { label: 'Stripe', value: 'STRIPE', icon: stripeLogo },
  { label: 'Metronome', value: 'METRONOME', icon: metronomeLogo },
] as const;
